import { render, staticRenderFns } from "./AssetPopup.vue?vue&type=template&id=4503cde3&"
import script from "./AssetPopup.vue?vue&type=script&lang=js&"
export * from "./AssetPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports